// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__15LM-","addColumnButton":"App_addColumnButton__2zWkC"};